// Vendor JS
import Debug from 'debug';
import axios from "axios";
import qs from 'qs';

class CigNotify {
	// How long to wait before flagging post as read
	flagPostReadDelay = 30000; // TODO: make this a DB setting for the plugin that can be set through the admin page

	// The total number of alerts
	totalAlertsCount = null;

	init = () => {
		this.addNotificationBarEventListeners();
	}

	/**
	 *  After a user has been on the page for 30 seconds updated DB to flag the post as read
	 */
	flagPostRead = () => {
		setTimeout(async () => {
			const postId = document.querySelector('article.post').getAttribute('data-id') || null; // Check for post id data attribute

			// Avoid running on forum posts that do not have an id attribute
			if (postId !== null) {
				try {
					const qsParams = qs.stringify({ post_id: postId });

					const response = await axios.post(`/wp-ajax/?action=cig_notification_post_read`, qsParams);

					if (response.status === 200) {
						Debug(`cig:info:sage:class:CigNotify`)(`Cig notifications flagPostRead success!`);
						Debug(`cig:info:sage:class:CigNotify`)(`flagPostRead response.data: %o`, response.data);
					} else {
						Debug(`cig:error:sage:class:CigNotify`)(`Cig notifications flagPostRead error!`);
						Debug(`cig:error:sage:class:CigNotify`)(`flagPostRead response: %o`, response);
					}

				} catch (err) {
					Debug(`cig:error:sage:class:CigNotify`)(`flagPostRead Error: %s %o`, err.message, err);
					throw new Error(err);
				}
			}

		}, this.flagPostReadDelay);
	};

	/**
	 * HTML Template for alert rows
	 *
	 * @param {int} post.id The post's ID (post_id property)
	 * @param {string} post.title The post's title (post_title property)
	 * @param {string} post.link The post's permalink
	 * @param {string} post.publicationNames The publication terms
	 * @param {string} post.shortDate Short date ie. Fri, Nov 23 (for mobile)
	 * @param {string} post.longDate Long date ie. Friday, November 23
	 *
	 * @return {string} The alert row markup
	 */
	getAlertRowMarkup = post => (
		`<div class="post">
			<div class="close-post-button">
				<button type="button" class="close-post" data-dismiss="post" data-post-id="${post.id}" aria-label="Dismiss Post">
					<span aria-hidden="true"><i class="fa fa-times" aria-hidden="true"></i></span>
				</button>
			</div>
			<div class="post-alert">
				<h5 class="alert-detail-title"><a href="${post.link}">${post.title}</a></h5>
				<h6 class="alert-detail-meta">
					${post.publicationNames}&nbsp;&#47;&nbsp;
					<span class="long-date">${post.longDate}</span>
					<span class="short-date">${post.shortDate}</span>
				</h6>
			</div>
		</div>`);

	/**
	 * Get an array of alert objects and build markup for each
	 */
	getAlerts = async () => {
		try {
			let markup = '';
			const response = await axios.get(`/wp-ajax/?action=cig_notification_get_alerts`);

			Debug(`cig:info:sage:class:CigNotify`)(`getAlerts response.data: %o`, response.data);

			if (response.status !== 200) {
				// do something?
			}

			if (response.data && response.data.length) {
				response.data.forEach(post => {
					markup += this.getAlertRowMarkup(post);
				});
			}

		} catch (err) {
			Debug(`cig:error:sage:class:CigNotify`)(`getAlerts Error: %s %o`, err.message, err);
			throw new Error(err);
		}

		return markup || '';
	};

	/**
	 * Get total number of alerts (may be more than the 10 displayed) and set the totalAlertsCount value
	 */
	getAlertsTotalCount = async () => {
		try {
			const response = await axios.get(`/wp-ajax/?action=cig_notification_get_alerts_count`);

			Debug(`cig:info:sage:class:CigNotify`)('getAlertsTotalCount response: %o', response);

			return response.data;

		} catch (err) {
			Debug(`cig:error:sage:class:CigNotify`)(`getAlertsTotalCount Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * Send AJAX request to mark all alerts as read
	 */
	markAllAlertsRead = async () => {
		try {
			const response = await axios.post(`/wp-ajax/?action=cig_notification_mark_all_read`);

			if (response.status !== 200) {
				Debug(`cig:error:sage:class:CigNotify`)(`Cig notifications markAllAlertsRead error!`);
				Debug(`cig:error:sage:class:CigNotify`)(`markAllAlertsRead response: %o`, response);

			} else {
				Debug(`cig:info:sage:class:CigNotify`)(`Cig notifications markAllAlertsRead Successful!`);

				// Hide the alert container
				document.querySelector('#alert-container').style.display = 'none';
			}

		} catch (err) {
			Debug(`cig:error:sage:class:CigNotify`)(`markAllAlertsRead Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * Add Event Handlers for modal related actions
	 */
	addModalHandlers = () => {
		// The X on the notification bar that opens the modal
		const alertRibbonXButton = document.getElementById('read-all-notifications');

		// Modal Buttons
		const modalMarkAllReadButton = document.getElementById('cig-notify-confirm-read-all');
		const modalCloseButton = document.getElementById('cig-notify-confirm-close');

		// Show modal when clicking the X on the alerts ribbon
		if (alertRibbonXButton) {
			alertRibbonXButton.addEventListener('click', this.showModalHandler);
		}

		// Clicking Mark all as read reloads the page so no need to hide modal
		if (modalMarkAllReadButton) {
			modalMarkAllReadButton.addEventListener('click', this.markAllAlertsRead);
		}

		// Hide modal when clicking close on the modal
		if (modalCloseButton) {
			modalCloseButton.addEventListener('click', this.hideModalHandler);
		}

		// Hide Modal on desktops and touch screens if window is clicked
		window.addEventListener('click', this.windowHideModalHandler);
		window.addEventListener('touchend', this.windowHideModalHandler);
	};

	// TODO: Combine the three toggle handlers into one
	/**
	 * Show Modal Handler for X on alerts bar
	 */
	showModalHandler = () => {
		const modal = document.getElementById('cig-notification-close-all-modal');
		modal.style.display = 'block';
	};

	/**
	 * Hide Modal Handler for close button
	 */
	hideModalHandler = () => {
		const modal = document.getElementById('cig-notification-close-all-modal');
		modal.style.display = 'none';
	};

	/**
	 * Hide Modal Handler for window
	 */
	windowHideModalHandler = event => {
		const modal = document.getElementById('cig-notification-close-all-modal');
		if (event.target === modal) {
			this.hideModalHandler(event);
		}
	};

	/**
	 * Alert Ribbon details toggle handler
	 */
	alertBarDetailToggleHandler = event => {
		const alertsContainer = event.target.closest('.alert-container');
		const alertDetails = alertsContainer ? alertsContainer.querySelector('.alert-details') : null;
		const toggleButton = event.target.closest('.toggle');

		// Make sure elements exist
		if (toggleButton && alertDetails) {
			// If the toggle is open remove the on class otherwise it's closed so add the on class to open it
			if (toggleButton.classList && toggleButton.classList.contains('on')) {
				toggleButton.classList.remove('on');
			} else {
				toggleButton.classList.add('on');
			}

			if (alertDetails.classList && alertDetails.classList.contains('open')) {
				alertDetails.classList.remove('open');
			} else {
				alertDetails.classList.add('open');
			}
		}
	};

	/**
	 * Add Event Handler for details toggle
	 * @param container the alert ribbon container (there currently is only one in use, but there could be more in the future)
	 */
	addAlertBarDetailToggleHandler = container => {
		const toggleTab = container.querySelector('.toggle-tab');

		if (toggleTab) {
			toggleTab.addEventListener('click', this.alertBarDetailToggleHandler);
		}
	};

	/**
	 * Add all event handlers for each alert ribbon
	 */
	addAlertBarHandlers = () => {
		// Get all alert bars (currently using just one, but may have more in the future)
		const containers = document.querySelectorAll('.alert-container');

		if (containers) {
			containers.forEach(container => {
				const alertDetails = container.querySelector('.alert-details');

				// Make sure there are alerts that are being shown
				if (alertDetails) {
					this.addAlertBarDetailToggleHandler(container);
					this.addRemoveAlertHandlers(container);
				}
			});
		}
	};

	/**
	 * Remove/close individual Alert
	 */
	removeAlertHandler = async event => {
		const alertsContainer = event.target.closest('.alert-container');
		const alertRow = event.target.closest('.post');
		const xButton = alertRow.querySelector('.close-post');
		const postId = xButton.getAttribute('data-post-id') || null; // Check for post id data attribute
		const type = xButton.getAttribute('data-dismiss') || null; // Check for alert type data attribute

		// If required attributes are present
		if (postId !== null && type !== null && xButton !== null) {
			xButton.innerHTML = '<i class="fa fa-refresh fa-spin"></i>'; // Show spinning icon instead of X

			try {

				const qsParams = qs.stringify({
					obj_id: postId,
					type,
				});

				const response = await axios.post(`/wp-ajax/?action=cig_notification_close`, qsParams);

				if (response.status !== 200) {
					// TODO: add some notification for the user to know the attempt failed
					Debug(`cig:error:sage:class:CigNotify`)(`Cig notifications removeAlert error! Unable to close alert`);
					Debug(`cig:error:sage:class:CigNotify`)(`removeAlertHandler Response: %o`, response);

				} else {
					Debug(`cig:info:sage:class:CigNotify`)(`Cig notifications removeAlert successful!`);

					// Get total number of alerts
					const alertCounter = alertsContainer.querySelector('.alert-body .num-posts');
					if (alertCounter) {

						// If totalAlertsCount isn't set use the value in the markup
						this.totalAlertsCount = (this.totalAlertsCount !== null) ? this.totalAlertsCount : parseInt(alertCounter.innerHTML, 10);

						// If there are alerts update the alerts shown and the count
						if (this.totalAlertsCount > 1) {
							const alertDetails = alertsContainer.querySelector('.alert-details');
							const detailContent = alertDetails.querySelector('.detail-content');

							// Get remaining alerts and output updated markup
							const responseAlerts = await this.getAlerts();

							// Swap markup and re-apply event listeners to each alert bar
							detailContent.innerHTML = responseAlerts;
							this.addRemoveAlertHandlers(alertsContainer);

							// Update totalAlertsCount and the value shown in the markup
							const responseAlertsCount = await this.getAlertsTotalCount();
							this.totalAlertsCount = responseAlertsCount;
							alertCounter.innerHTML = responseAlertsCount;

							// No more alerts remove the alert ribbon
						} else {
							alertsContainer.remove();
						}
					}
				}

			} catch (err) {
				Debug(`cig:error:sage:class:CigNotify`)(`Cig notifications removeAlertHandler error! Unable to close alert`);
				throw new Error(err);
			}
		}
	};

	/**
	 * Add event handlers for closing/removing alerts
	 */
	addRemoveAlertHandlers = (container) => {
		// X buttons to the left of each individual alert
		const closePostButtons = container.querySelector('.alert-details').querySelectorAll('.close-post');

		// Add Event listener to each X button on each alert
		closePostButtons.forEach(button => {
			button.addEventListener('click', this.removeAlertHandler);
		});
	};

	/**
	 * Add All Event Listeners
	 */
	addNotificationBarEventListeners = () => {
		this.addModalHandlers();
		this.addAlertBarHandlers();
	};
}

export default new CigNotify();
